import { render, staticRenderFns } from "./managedInstructionAssignmentDate.vue?vue&type=template&id=6b57f3df"
import script from "./managedInstructionAssignmentDate.vue?vue&type=script&lang=js"
export * from "./managedInstructionAssignmentDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports